import React, {PureComponent} from "react"
import id from "@irati/utils/id"
import {StatementItem} from "@irati/types"
import StatementItemTypes from "@irati/wallet/types/enums/StatementItemTypes"

import PerksGOCashback from "./PerksGO/Cashback"
import Spend from "./Spend"
import SpendRefund from "./SpendRefund"
import ManualCredit from "./ManualCredit"
import SendCreditAsReward from "./SendCreditAsReward"
import UseCreditToBuyReward from "./UseCreditToBuyReward"
import TopUp from "./TopUp"
import TransferToRewardsWallet from "./TransferToRewardsWallet"
import RefundFromRewardsWallet from "./RefundFromRewardsWallet"
import SendCredit from "./SendCredit"
import ManualRefund from "./ManualRefund"
import SendCreditAsRewardRefund from "./SendCreditAsRewardRefund"
import MontlyTTTopUp from "./MontlyTTTopUp"
import ExpireTreatTokens from "./ExpireTreatTokens"
import PointsBack from "./PointsBack"
import RewardPointsTopUp from "./RewardPointsTopUp"
import RewardPointsTransfer from "./RewardPointsTransfer"
import RewardPointsRewarded from "./RewardPointsRewarded"

interface Props {
  className?: string | null,
  statementItem: StatementItem,
  id?: string,
  isRewardWallet?: boolean,
  isTenantWallet?: boolean
}

class StatementItemClass extends PureComponent<Props> {
  static defaultProps = {
    className: null,
    isRewardWallet: false,
    isTenantWallet: false
  }

  render() {
    const {className, statementItem, isRewardWallet, isTenantWallet} = this.props

    const {
      transfer: {type}
    } = statementItem

    switch (type) {
      case StatementItemTypes.PERKS_GO_CASHBACK: {
        const idNamespace = id("perks-go-cashback", this.props)
        return <PerksGOCashback id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.SPEND: {
        const idNamespace = id("spend", this.props)
        return <Spend id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.SPEND_REFUND: {
        const idNamespace = id("spend-refund", this.props)
        return <SpendRefund id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.MANUAL_CREDIT: {
        const idNamespace = id("manual-credit", this.props)
        return <ManualCredit id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.SEND_CREDIT_AS_REWARD: {
        const idNamespace = id("send-credit-as-reward", this.props)
        return <SendCreditAsReward id={idNamespace} className={className} isRewardWallet={isRewardWallet} statementItem={statementItem} />
      }
      case StatementItemTypes.USE_CREDIT_TO_BUY_REWARD: {
        const idNamespace = id("use-credit-to-buy-reward", this.props)
        return <UseCreditToBuyReward id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.TRANSFER_TO_REWARDS_WALLET: {
        const idNamespace = id("transfer-to-rewards-wallet", this.props)
        return (
          <TransferToRewardsWallet id={idNamespace} isTenantWallet={isTenantWallet} className={className} statementItem={statementItem} />
        )
      }
      case StatementItemTypes.NEW_TOP_UP_BANK_TRANSFER:
      case StatementItemTypes.TOP_UP_BANK_TRANSFER: {
        const idNamespace = id("topup-bank-transfer", this.props)
        return <TopUp id={idNamespace} isBankTransfer className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.NEW_TOP_UP_CARD_PAYMENT:
      case StatementItemTypes.TOP_UP_CARD_PAYMENT: {
        const idNamespace = id("topup-card-payment", this.props)
        return <TopUp id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.REFUND_FROM_REWARDS_WALLET: {
        const idNamespace = id("refund-from-rewards-wallet", this.props)
        return (
          <RefundFromRewardsWallet id={idNamespace} isTenantWallet={isTenantWallet} className={className} statementItem={statementItem} />
        )
      }
      case StatementItemTypes.SEND_CREDIT: {
        const idNamespace = id("send-credit", this.props)
        return <SendCredit id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.MANUAL_REFUND: {
        const idNamespace = id("manual-refund", this.props)
        return <ManualRefund id={idNamespace} className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.SEND_CREDIT_AS_REWARD_REFUND: {
        const idNamespace = id("send-credit-as-reward-refund", this.props)
        return (
          <SendCreditAsRewardRefund id={idNamespace} className={className} statementItem={statementItem} isRewardWallet={isRewardWallet} />
        )
      }
      case StatementItemTypes.MONTHLY_TREAT_TOKEN_TOP_UP: {
        const idNamespace = id("monthly-tt-top-up", this.props)
        return (
          <MontlyTTTopUp id={idNamespace} className={className} statementItem={statementItem} isRewardWallet={isRewardWallet} />
        )
      }
      case StatementItemTypes.EXPIRE_TREAT_TOKENS: {
        const idNamespace = id("expired-treat-tokens", this.props)
        return (
          <ExpireTreatTokens id={idNamespace} statementItem={statementItem} isRewardWallet={isRewardWallet} />
        )
      }
      case StatementItemTypes.POINTS_BACK: {
        const idNamespace = id("points-back", this.props)
        return (
          <PointsBack id={idNamespace} className={className} statementItem={statementItem} isRewardWallet={isRewardWallet} />
        )
      }
      case StatementItemTypes.TOP_UP_FLEXI: {
        return <RewardPointsTopUp isSystemTransfer className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.TOP_UP_CARD_PAYMENT_FLEXI: {
        return <RewardPointsTopUp className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.TOP_UP_BANK_TRANSFER_FLEXI: {
        return <RewardPointsTopUp isBankTransfer className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.TRANSFER: {
        return <RewardPointsTransfer className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.REWARD: {
        return <RewardPointsRewarded className={className} statementItem={statementItem} />
      }
      case StatementItemTypes.REWARD_POINTS_EXPIRY: {
        const idNamespace = id("expired-reward-points", this.props)
        return <ExpireTreatTokens id={idNamespace} statementItem={statementItem} />
      }
      default: {
        return null
      }
    }
  }
}

export default StatementItemClass
